import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=bf2a1c1e&scoped=true&"
import script from "./InfoBar.vue?vue&type=script&lang=js&"
export * from "./InfoBar.vue?vue&type=script&lang=js&"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=bf2a1c1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2a1c1e",
  null
  
)

export default component.exports